import { useQuery } from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import { LtrScoreResult } from '../types/LtrScoreResult';

export const useGetLtrScore = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['retail-order/ltr-score'],
        queryFn: async () => await apiClient.get('retail-order/ltr-score') as LtrScoreResult,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
        refetchOnWindowFocus: false,
    });

    return {
        data,
        isLoading
    };
};
